import React, { useState, useEffect } from "react";
import TextField from "@mui/material/TextField";
import PropTypes from "prop-types";

const isEmpty = (value) => value.replace(" ", "").replace(/<div><br><\/div>/g, "").length === 0;

const requiredValidator = (value, identifier) =>
    isEmpty(value) ? `${identifier} is required` : null;

const DSTextField = React.forwardRef(
    (
        {
            required,
            error,
            helperText,
            identifier,
            hideError,
            value,
            children,
            validators,
            useValidators,
            ...props
        },
        ref,
    ) => {
        const [hasError, setHasError] = useState(false);
        const [validatorsText, setValidatorsText] = useState(false);

        useEffect(() => {
            const vals = [...validators];
            if (required) {
                vals.push(requiredValidator);
            }
            const results = vals.map((fn) => fn(value, identifier)).filter((r) => !!r);
            setValidatorsText(results?.[0] || null);
            setHasError(!!results.length);
        }, [value, required, validators]);

        const isError = !hideError && (error || hasError);
        const subText = isError && useValidators ? validatorsText : helperText;
        return (
            <TextField
                ref={ref}
                required={required}
                helperText={subText}
                value={value}
                error={isError}
                {...props}
            >
                {children}
            </TextField>
        );
    },
);

DSTextField.propTypes = {
    required: PropTypes.bool,
    error: PropTypes.bool,
    helperText: PropTypes.node,
    hideError: PropTypes.bool,
    value: PropTypes.node,
    identifier: PropTypes.string,
    validators: PropTypes.array,
    useValidators: PropTypes.bool,
};

DSTextField.defaultProps = {
    required: false,
    error: false,
    helperText: null,
    hideError: false,
    value: null,
    identifier: "This field",
    validators: [],
    useValidators: true,
};

export default React.memo(DSTextField);
